import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state = {
  //要设置的全局访问的state对象
  userinfo: '', //用户信息
  ChargingID: '', //充电桩ID
  ChargingCardID: '',
  adminuserinfo: '',
  setIphoneShareUrl: '',
  appName: process.env.VUE_APP_APP_NAME, // 平台名称（env 兜底，webconfig 的 platformTitle 覆盖）
};
const getters = {
  // 水印文本：由平台名称去掉结尾「平台」派生
  watermarkText: (state) => (state.appName || '').replace(/平台$/, ''),
};
const mutations = {
  // 设置平台名称
  setAppName(state, name) {
    state.appName = name;
  },
  //存入充电桩id
  setChargingID(state, id) {
    state.ChargingID = id;
  },
  setIphoneShareUrl(state, url) {
    state.setIphoneShareUrl = url;
  },
  setUser(state, obj) {
    state.userinfo = obj;
  },
  setChargingCardID(state, id) {
    state.ChargingCardID = id;
  },
  setAdminUser(state, obj) {
    state.adminuserinfo = obj;
  },
};
const actions = {
  setAppName(context, name) {
    context.commit('setAppName', name);
  },
  setChargingID(context, id) {
    context.commit('setChargingID', id);
  },
  setIphoneShareUrl(context, url) {
    context.commit('setIphoneShareUrl', url);
  },
  setUser(context, obj) {
    context.commit('setUser', obj);
  },
  setChargingCardID(context, id) {
    context.commit('setChargingCardID', id);
  },
  setAdminUser(context, obj) {
    context.commit('setAdminUser', obj);
  },
};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
});

export default store;
